import { Row } from '@design-system/components/grid/grid';
import { SearchInput } from '@design-system/components/searchinput';
import { extrasVM } from '../Extras.page';

import { DropDownFilter } from '@design-system/components/dropDown/dropDownFilter';
import { filterTypeOptions } from '../viewModel/extras.mappers';

export const ExtrasFilters = () => {
  const vm = extrasVM.useValue();
  return (
    <Row alignCenter className="flex justify-start">
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '312px 150px',
          gap: '16px',
        }}
      >
        <SearchInput
          placeholder="Search by name"
          value={vm.search}
          onChange={(e) => vm.dispatch('SetSearch', e.target.value)}
          onClear={() => vm.dispatch('SetSearch', '')}
        />
        <DropDownFilter
          options={filterTypeOptions}
          onSelect={(value) => vm.dispatch('SetFilterType', value || '')}
          value={vm.filters.type}
          label="Content type"
        />
      </div>
    </Row>
  );
};
